(function moreCommunitiesSection() {
  'use strict';

  const nearbyContainer = document.querySelector('[data-nearby-section]');
  function handlerMoreCommunityClick(event) {
    const target = event.target;
    const cardElement = target.closest('[data-card-element]');
    const card = target.closest('[data-card]');
    const link = card.querySelector('[data-link]');

    if (!card) {
      return;
    }

    if (cardElement &&
      (cardElement.dataset.cardElement === 'favoriteButton' || cardElement.dataset.cardElement === 'priceReduction')) {
      return;
    }

    link.click();
  }

  document.body.addEventListener(
    'moreCommunitiesLoaded',
    () => nearbyContainer.addEventListener('click', handlerMoreCommunityClick)
  );
}());
